"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = createClient;
var _routing = require("../../routing.cjs");
var _index = require("../../types/index.cjs");
function createClient(api) {
  async function list(scope) {
    const {
      senders
    } = await api.get(_routing.routing.senderAddressesUrl, {
      query: {
        scope: _index.Query.stringify(scope)
      }
    });
    return senders;
  }
  async function create(payload) {
    const {
      sender
    } = await api.post(_routing.routing.senderAddressesUrl, {
      payload
    });
    return sender;
  }
  async function get(senderId) {
    const {
      sender
    } = await api.get(`${_routing.routing.senderAddressesUrl}/${senderId}`);
    return sender;
  }
  async function update(senderId, payload) {
    const {
      sender
    } = await api.patch(`${_routing.routing.senderAddressesUrl}/${senderId}`, {
      payload
    });
    return sender;
  }
  async function doDelete(senderId) {
    return api.delete(`${_routing.routing.senderAddressesUrl}/${senderId}`);
  }
  return {
    list,
    create,
    get,
    update,
    delete: doDelete
  };
}